import { createUseStyles, subtract } from '@pushpay/styles';
import { sidebarCollapsedWidthPx } from '../sidebar';
const itemBorderWidth = '5px';
export const itemPaddingH = '22px';
export const useNavigationStyles = createUseStyles(theme => ({
  root: {
    color: theme.colors['color-text-default']
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  listItem: {
    '& + &': {
      marginTop: '2px'
    }
  },
  childExpandList: {
    marginTop: '2px'
  },
  itemGroup: {},
  itemGroupArrow: {
    font: theme.TYPOGRAPHY.BODY_2,
    transition: 'transform 150ms'
  },
  itemGroupArrowUp: {
    transition: 'transform 150ms'
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexGrow: 1,
    width: '100%',
    paddingLeft: itemPaddingH,
    paddingRight: itemPaddingH,
    height: '48px',
    overflow: 'hidden',
    '& + &': {
      marginTop: '2px'
    },
    '&:hover': {
      backgroundColor: theme.colors['product-color-light-400']
    },
    '&:focus-visible': {
      outlineOffset: '-1px',
      outline: '1px auto',
      outlineColor: theme.colors['product-color']
    }
  },
  itemActive: {
    backgroundColor: theme.colors['product-color-light-400'],
    paddingLeft: subtract(itemPaddingH, itemBorderWidth),
    borderLeft: `${itemBorderWidth} solid ${theme.colors['product-color']}`,
    color: theme.colors['product-color'],
    fontWeight: 600
  },
  itemOpen: {
    backgroundColor: theme.colors['product-color-light-400'],
    color: theme.colors['product-color']
  },
  childExpandItem: {
    height: theme.SPACING.XLARGE,
    paddingRight: itemPaddingH,
    paddingLeft: `${sidebarCollapsedWidthPx}px`
  },
  childExpandItemActive: {
    fontWeight: 400,
    paddingLeft: subtract(`${sidebarCollapsedWidthPx}px`, itemBorderWidth)
  },
  childFlyoutItem: {
    height: theme.SPACING.XLARGE,
    paddingLeft: theme.SPACING.SMALL,
    paddingRight: theme.SPACING.SMALL
  },
  childFlyoutItemActive: {
    paddingLeft: subtract(theme.SPACING.SMALL, itemBorderWidth)
  },
  label: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-start',
    marginLeft: itemPaddingH,
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },
  icon: {
    flexShrink: 0,
    fontSize: theme.SPACING.LARGE_ICON_SIZE
  },
  iconWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  collapsedIndicatorIcon: {
    position: 'absolute',
    flexShrink: 0,
    fontSize: theme.SPACING.SMALL_ICON_SIZE,
    top: '-4px',
    right: '-12px'
  },
  expandedIndicatorIcon: {
    marginLeft: theme.SPACING.XXSMALL,
    fontSize: theme.SPACING.FIELD_ICON_SIZE
  },
  tooltip: {
    display: 'flex'
  }
}));